import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../Redux";
import settingReducer from "../../../../Redux/reducers/setting";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import ModelContainer from "../../../Components/ModelContainer";
import Select from "../../../Components/Select";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorContainer from "../../../Components/ErrorContainer";
import DatePicker from "react-date-picker";
import ListDateInput from "../../../Components/ListDateInput";
import moment from "moment";

const ScheduledPriceUpdate = (params) => {
  const [modalType, setModalType] = useState("add");
  const dispatch = useDispatch();
  const scheduled_prices = useSelector(
    (state) => state?.menuReducer?.menuScheduledPricingDetails?.scheduled_prices
  );
  const scheduled_prices_history = useSelector(
    (state) =>
      state?.menuReducer?.menuScheduledPricingDetails?.scheduled_prices_history
  );
  console.log(scheduled_prices, "scheduled_prices");
  useEffect(() => {
    dispatch(actions?.getScheduledMenuPricingDetails());
  }, []);

  const pricingModalState = useSelector(
    (state) => state?.menuReducer?.menu_new_pricing_modal_state
  );
  const setPricingModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "menu_new_pricing_modal_state",
        modalState: state,
      })
    );
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div class="row mx-0">
              <div class="shadowclass no-bg px-0">
                <div class="top-header-sec mb-3">
                  <div class="counts">
                    <h4 class="event-alert pt-0">
                      Upcoming Scheduled Pricing{" "}
                    </h4>
                    <div class="row justify-content-between align-items-center w-100 mx-0">
                      <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div class="search-box mt-0">
                          <form
                            action="/productions"
                            id="MenuItemIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            {" "}
                            <input
                              name="keyword"
                              placeholder="Search"
                              type="text"
                              id="MenuItemKeyword"
                            />{" "}
                            <input type="submit" />
                          </form>
                        </div>{" "}
                      </div>
                      <div class="btns col-sm-7 col-12 align-right px-0 d-flex align-items-center justify-content-end">
                        <button
                          onClick={() => {
                            setPricingModalState(true);
                            setModalType("add");
                          }}
                          type="button"
                          class="btn green-btn-revert add-plus addAccounts mx-0"
                          id="add_new_price_schedule"
                        >
                          <i class="i-icon"> </i> Add New Pricing Schedule
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="shadowclass my-0">
                <div className="table-responsive">
                  <table className="checklist-table">
                    <thead>
                      <tr>
                        <th> Menu Item Name </th>
                        <th> Sales Type </th>
                        <th width="15%"> Current Price </th>
                        <th> New Price </th>
                        <th width="10%"> Effective Pricing Date </th>
                        <th className="action-td">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {scheduled_prices?.length > 0 ? (
                        scheduled_prices?.map((item) => {
                          return (
                            <tr>
                              <td>{item?.menu_item?.menu_item_name}</td>
                              <td>{item?.sales_type?.type_name}</td>
                              <td>{item?.current_price}</td>
                              <td>{item?.new_price}</td>
                              <td>{item?.effective_date}</td>
                              <td>
                                <div class="event-time-edit p0">
                                  <a
                                    onClick={() => {
                                      setPricingModalState(true);
                                      dispatch(
                                        actions?.saveEditScheduledMenuItem(item)
                                      );
                                      setModalType("edit");
                                    }}
                                    class="editPeriodMain"
                                  >
                                    <i class="iconSprites edit-icon"></i>
                                  </a>
                                  <a
                                    onClick={() => {
                                      dispatch(
                                        actions?.deleteScheduleMenuItem({
                                          id: item?.id,
                                        })
                                      );
                                    }}
                                    class="deletePeriodMain"
                                  >
                                    <i class="iconSprites delete-icon"></i>
                                  </a>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colspan="6" class="text-center">
                            No record found!
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div class="pagination justify-content-end">
                  <span class="prev">Previous</span>{" "}
                  <span class="next">Next</span>{" "}
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="shadowclass no-bg px-0 top-header-sec">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert pt-0">Scheduled Pricing History</h4>
                    <div class="row justify-content-between align-items-center w-100 mx-0">
                      <div class="col-lg-4 col-md-5 px-0 mb-0">
                        <div class="search-box mt-0">
                          <form
                            action="/productions"
                            id="MenuItemIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            {" "}
                            <input
                              name="keyword"
                              placeholder="Search"
                              type="text"
                              id="MenuItemKeyword"
                            />{" "}
                            <input type="submit" />
                          </form>
                        </div>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="shadowclass my-0">
                <div className="table-responsive">
                  <table className="checklist-table">
                    <thead>
                      <tr>
                        <th> Menu Item Name </th>
                        <th> Sales Type </th>
                        <th width="15%"> Current Price </th>
                        <th> New Price </th>
                        <th width="10%"> Effective Pricing Date </th>
                        <th className="action-td">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {scheduled_prices_history?.map((el) => (
                        <tr>
                          <td class="menu-item-name-td">
                            {" "}
                            <strong>
                              {el?.menu_item?.menu_item_name}{" "}
                            </strong>{" "}
                          </td>
                          <td>
                            <span>{el?.sales_type?.type_name} </span>
                          </td>

                          <td> {el?.current_price} </td>
                          <td> {el?.new_price} </td>
                          <td> {el?.effective_date} </td>

                          <td> </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div class="pagination justify-content-end">
                  <span class="prev">Previous</span>{" "}
                  <span class="next">Next</span>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        <NewPricingModel
          pricingModalState={pricingModalState}
          setPricingModalState={setPricingModalState}
          setModalType={setModalType}
          modalType={modalType}
        />
      </div>
    </UserInterface>
  );
};

const NewPricingModel = ({
  pricingModalState,
  setPricingModalState,
  modalType,
  setModalType,
}) => {
  const dispatch = useDispatch();

  const salesTypeOptions = useSelector(
    (state) => state?.menuReducer?.menuItemSalesType
  );
  const menuPricingDetails = useSelector(
    (state) => state?.menuReducer?.menuPricingDetails
  );
  const posMenuitemsPrice = useSelector(
    (state) =>
      state?.menuReducer?.menuItemSalesType?.salesList?.posMenuitemsPrice
  );

  const menuSearchResult = useSelector(
    (state) => state?.menuReducer?.menuSearchResult
  );

  const defaultEditState = useSelector(
    (state) => state?.menuReducer?.editScheduleMenuItem
  );

  const [inputVal, setInputVal] = useState("");
  const [count, setCount] = useState(0);
  const [tableState, setTableState] = useState([]);
  const tableObj = {
    uniqueId: count,
    menu_item_id: false,
    sales_type: "",
    current_price: false,
    new_price: false,
    effective_date: "",
    salesTypeOptions: null,
    menuSearchList: null,
    menuItemName: "",
    searchBox: "close",
  };

  useEffect(() => {
    if (modalType === "edit") {
      dispatch(
        actions?.getSalesType({
          menu_item_id: defaultEditState?.menu_item_id,
          uniqueId: 1,
        })
      );
      const editObj = {
        uniqueId: 1,
        id: defaultEditState?.id,
        menu_item_id: defaultEditState?.menu_item_id,
        sales_type: +defaultEditState?.sales_type_id,
        current_price: defaultEditState?.current_price,
        new_price: defaultEditState?.new_price,
        effective_date: defaultEditState?.effective_date,
        searchBox: "close",
        menuItemName: defaultEditState?.menu_item?.menu_item_name,
      };
      setTableState([editObj]);
    }
  }, [modalType, defaultEditState]);
  const schema = yup
    .object({
      tableItem: yup.array().of(
        yup.object().shape({
          sales_type: yup.number().required(),
          effective_date: yup.string().required(),
          new_price: yup.number().required(),
        })
      ),
    })
    .required();

  useEffect(() => {
    reset({ tableItem: tableState });
    console.log(tableState, "copyTableState");
  }, [tableState]);

  useEffect(() => {
    const copyTableState = JSON.parse(JSON.stringify(tableState));
    copyTableState?.forEach((item) => {
      if (item?.uniqueId === menuSearchResult?.uniqueId) {
        item["menuSearchList"] = menuSearchResult?.searchList;
      }
    });
    setTableState(copyTableState);
  }, [menuSearchResult]);

  useEffect(() => {
    const copyTableState = JSON.parse(JSON.stringify(tableState));
    copyTableState?.forEach((item) => {
      if (item?.uniqueId === salesTypeOptions?.uniqueId) {
        item["salesTypeOptions"] = salesTypeOptions?.salesList?.salesTypeNames;
      }
    });
    setTableState(copyTableState);
  }, [salesTypeOptions]);

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: { tableItem: tableState },
  });

  function submitData() {
    dispatch(actions?.postScheduledMenuPricingDetails({ prices: tableState }));
    setTableState([]);
    setModalType("add");
  }
  function checkError(key, errors, idx) {
    return Object.keys(errors?.tableItem?.[idx] ?? {})?.find(
      (el) => el === key
    ) === key
      ? true
      : false;
  }
  return (
    <ModelContainer
      title={"Schedule Menu Pricing Update"}
      open={pricingModalState}
      closeModal={() => {
        setPricingModalState(false);
        setTableState([]);
        setModalType("add");
      }}
      submitModal={async () => {
        const res = await trigger();
        console.log(res, "res");
        if (res) submitData();
      }}
      isExtraLarge={true}
    >
      <>
        <div className="mb-4">
          <table className="checklist-table">
            <thead>
              <tr>
                <th> Menu Item Name </th>
                <th> Sales Type </th>
                <th width="15%"> Current Price </th>
                <th> New Price </th>
                <th width="10%"> Effective Pricing Date </th>
                {modalType === "add" ? (
                  <th className="action-td">Actions</th>
                ) : (
                  ""
                )}
              </tr>
            </thead>
            <tbody>
              {tableState?.map((row, idx) => (
                <tr>
                  <td>
                    <div class="select-div search-select-ms">
                      <div
                        class="select2-container required menu_item_id"
                        id="s2id_menu_item_id0"
                      >
                        <a
                          onClick={() => {
                            const copyState = [...tableState];
                            copyState?.forEach((item) => {
                              if (item?.uniqueId === row?.uniqueId) {
                                item["searchBox"] =
                                  item?.searchBox === "close"
                                    ? "open"
                                    : "close";
                              }
                            });

                            setTableState(copyState);
                          }}
                          href="#"
                          className="select2-choice select2-default"
                        >
                          {" "}
                          <span
                            className="select2-chosen"
                            id="select2-chosen-2"
                          >
                            {row?.menuItemName === ""
                              ? "Search menu items"
                              : row?.menuItemName}
                          </span>
                          <span className="select2-arrow"></span>
                        </a>
                      </div>
                    </div>
                    <div
                      className={`searchSelect ${
                        row?.searchBox === "close" ? "hidden" : ""
                      }`}
                    >
                      <div class="select2-search">
                        <input
                          onChange={(e) => {
                            setInputVal(e.target.value);
                          }}
                          // onClick={(e) => console.log("asas")}
                          type="text"
                          value={inputVal}
                          class="select2-input"
                          id="s2id_autogen2_search"
                          placeholder=""
                        />{" "}
                        <button
                          onClick={(e) => {
                            dispatch(
                              actions?.searchMenuByName({
                                query: inputVal,
                                uniqueId: row?.uniqueId,
                              })
                            );
                          }}
                          className="searchBtn"
                        >
                          {" "}
                        </button>
                      </div>{" "}
                      <ul>
                        {row?.menuSearchList?.map((el) => (
                          <li
                            onClick={(e) => {
                              const copyState = JSON.parse(
                                JSON.stringify(tableState)
                              );
                              copyState?.forEach((item) => {
                                if (item?.uniqueId === row?.uniqueId) {
                                  item["searchBox"] =
                                    item?.searchBox === "close"
                                      ? "open"
                                      : "close";
                                  item["menu_item_id"] = el?.id;
                                  item["menuItemName"] = el?.text;
                                }
                              });

                              setTableState(copyState);
                              dispatch(
                                actions?.getSalesType({
                                  menu_item_id: el?.id,
                                  uniqueId: row?.uniqueId,
                                })
                              );
                              setInputVal("");
                            }}
                          >
                            <span>{el?.text}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td>
                    <div className="select-div input-group">
                      <select
                        // {...register(`tableItem.${idx}.sales_type`)}
                        onChange={(e) => {
                          const copyTableState = JSON.parse(
                            JSON.stringify(tableState)
                          );
                          copyTableState?.forEach((item) => {
                            if (item?.uniqueId === row?.uniqueId) {
                              item["sales_type"] = e.target.value;
                              item["current_price"] =
                                // menuPricingDetails?.currency +
                                posMenuitemsPrice?.[
                                  e.target.selectedIndex - 1
                                ]?.menu_price;
                            }
                          });
                          setTableState(copyTableState);
                        }}
                      >
                        <option value="">Select Sales Type</option>
                        {row?.salesTypeOptions?.map((el, idx) => (
                          <option value={el?.id}>{el?.type_name}</option>
                        ))}
                      </select>
                      <div className="error">
                        {checkError("sales_type", errors, idx) ? "error" : ""}
                      </div>
                    </div>
                  </td>
                  <td>{row?.current_price}</td>
                  <td>
                    <div class="count-unit col-5">
                      <span class="dolor-sign">$</span>
                      <input
                        // {...register(`tableItem.${idx}.new_price`)}
                        type="number"
                        className="w-100"
                        onChange={(e) => {
                          const copyState = [...tableState];
                          copyState?.forEach((item) => {
                            if (item?.uniqueId === row?.uniqueId) {
                              item["new_price"] = +e.target.value;
                            }
                          });

                          setTableState(copyState);
                        }}
                      />

                      <div className="error">
                        {checkError("new_price", errors, idx) ? "error" : ""}
                      </div>
                    </div>
                  </td>

                  <td class="calander-date">
                    <ListDateInput
                      // {...register(`tableItem.${idx}.effective_date`)}
                      dateFormat="dd/MM/yyyy"
                      selected={
                        row?.effective_date == ""
                          ? ""
                          : new Date(row?.effective_date)
                      }
                      onChange={(val) => {
                        const dateVal = moment(val).format("yyyy-MM-DD");
                        const copyState = JSON.parse(
                          JSON.stringify(tableState)
                        );
                        copyState?.forEach((item) => {
                          if (item?.uniqueId === row?.uniqueId) {
                            item["effective_date"] = `${dateVal}`;
                          }
                        });

                        setTableState(copyState);
                      }}
                    />
                    <div>
                      {checkError("effective_date", errors, idx) ? "error" : ""}
                    </div>
                  </td>
                  {modalType === "add" && (
                    <td>
                      <div class="d-flex justify-content-center">
                        <a
                          onClick={() => {
                            const copyTableState = JSON?.parse(
                              JSON.stringify(tableState)
                            );
                            copyTableState?.splice(idx, 1);
                            setTableState(copyTableState);
                          }}
                          class="deletePeriodMain circle_icon red"
                        >
                          <i class="iconSprites cancel-icon"></i>
                        </a>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          {modalType === "add" && (
            <button
              onClick={() => {
                setCount(count + 1);
                setTableState([...tableState, tableObj]);
              }}
              type="button"
              class="btn green-btn-revert add-plus addAccounts mx-0"
              id="add_new_price_schedule"
            >
              <i class="i-icon"> </i> Add New Pricing Schedule
            </button>
          )}
        </div>
      </>
    </ModelContainer>
  );
};

export default ScheduledPriceUpdate;
